import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'
import XHR from 'i18next-xhr-backend'
import rankES from './locales/es/translation.json'
import rankBG from './locales/bg/translation.json'
import rankEN from './locales/en/translation.json'

const defaultLanguage = localStorage.getItem('i18nextLng')

i18n
  .use(XHR)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      es: rankES,
      bg: rankBG,
      en: rankEN,
    },
    /* default language when load the website in browser */
    lng: defaultLanguage !== null ? defaultLanguage : 'en',
    /* When react i18next not finding any language to as default in borwser */
    fallbackLng: defaultLanguage !== null ? defaultLanguage : 'en',
    /* debugger For Development environment */
    debug: false,
    ns: ['translations'],
    defaultNS: 'translations',
    keySeparator: '.',
    interpolation: {
      escapeValue: false,
      formatSeparator: ',',
    },
    react: {
      wait: true,
      bindI18n: 'languageChanged loaded',
      bindStore: 'added removed',
      nsMode: 'default',
    },
  })

export default i18n
